import React, { Component } from 'react';
import { Row, Col, Button, Label, Card, CardBody, Form, Input, CustomInput, Popover, PopoverBody } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { StyledCard } from '../../Base/Common/CommonUIComponents';
import { putAPI } from '../../Base/API';
import { handleNotification } from '../../Base/Common/Notification';
import { profileCreationDefaultConfig, getProfileCreationConfig } from '../../Base/Common/ReferenceDataFunctions';


class ProfileCreationConfig extends Component {
    static displayName = ProfileCreationConfig.name;

    constructor(props) {
        super(props);
        this.state = {
            block: false,
            error: [],
            fieldsConfig: profileCreationDefaultConfig.map(f => ({ fieldKey: f.key, isRequired: f.alwaysRequired, regex: '' })),
            openPopover: null,
        };
    }

    componentDidMount() {
        this.getProfileConfig();
    }

    getProfileConfig = () => {
        this.setState({ block: true });

        getProfileCreationConfig(({ data, fieldsConfig, error }) => {
            if (error) {
                this.setState({ error: [{ message: error.message, stack: error.stack, messageType: 'danger' }], block: false });
                return;
            }
            if (data && data.errors && data.errors.length > 0) {
                handleNotification(data);
            }

            this.setState({ fieldsConfig, block: false });
        });
    }

    saveProfileCreationConfig = (e) => {
        e.preventDefault();

        this.setState({ block: true });

        putAPI(result => {
            const { data, error } = result;
            if (error) {
                this.setState({ error: [{ message: error.message, stack: error.stack, messageType: 'danger' }], block: false });
                return;
            }
            if (data) {
                handleNotification(data, <FormattedMessage id="ProfileCreationConfig.SaveSuccess" />, <FormattedMessage id="generic.success" />);
                this.setState({ block: false });
            }
        }, '/api/Voucher/Profile/v1/ProfileCreationConfig', JSON.stringify({ request: this.state.fieldsConfig }));
    }

    handleToggle = (fieldKey) => {
        this.setState(prev => ({
            fieldsConfig: prev.fieldsConfig.map(f =>
                f.fieldKey === fieldKey ? { ...f, isRequired: !f.isRequired } : f
            )
        }));
    }

    togglePopover = (fieldKey) => {
        this.setState(prev => ({ openPopover: prev.openPopover === fieldKey ? null : fieldKey }));
    }

    handleRegexChange = (fieldKey, e) => {
        const { value } = e.target;

        this.setState(prev => ({
            fieldsConfig: prev.fieldsConfig.map(f =>
                f.fieldKey === fieldKey ? { ...f, regex: value } : f
            )
        }));
    }

    render() {
        const { block, error, fieldsConfig, openPopover } = this.state;
        const { intl } = this.props;
        
        return (
            <StyledCard icon={'fa-solid fa-user-gear'} title="ProfileCreationConfig.Title" error={error} block={block}>
                <Form onSubmit={this.saveProfileCreationConfig.bind(this)}>
                    <Row className="mb-3">
                        <Col>
                            <Button type="submit" className="btn btn-sm btn-host float-right">
                                <i className="fa-solid fa-floppy-disk" />
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        {profileCreationDefaultConfig.map(field => {
                            const config = fieldsConfig.find(f => f.fieldKey === field.key) || { isRequired: field.alwaysRequired, regex: '' };
                            
                            return (
                                <Col key={field.key} md={6} className="mb-3">
                                    <Card className="shadow-sm h-100">
                                        <CardBody>
                                            <Row className="align-items-center mb-2">
                                                <Col className="d-flex align-items-center">
                                                    <b><FormattedMessage id={field.labelId} /></b>
                                                    {field.noteId && (
                                                        <>
                                                            <i id={`note-${field.key}`} className="fa-solid fa-circle-info ml-2 text-muted" style={{ cursor: 'pointer', fontSize: '0.9em' }} onClick={() => this.togglePopover(field.key)} />
                                                            <Popover target={`note-${field.key}`} isOpen={openPopover === field.key} toggle={() => this.togglePopover(field.key)} placement="top" >
                                                                <PopoverBody>
                                                                    <FormattedMessage id={field.noteId} />
                                                                </PopoverBody>
                                                            </Popover>
                                                        </>
                                                    )}
                                                </Col>
                                                <Col className="text-right d-flex align-items-center justify-content-end">
                                                    <Label className="mr-2 mb-0 text-muted">
                                                        <FormattedMessage id="ProfileCreationConfig.Required" />
                                                    </Label>
                                                    <CustomInput
                                                        type="switch"
                                                        id={`required-${field.key}`}
                                                        name={`required-${field.key}`}
                                                        checked={config.isRequired || false}
                                                        disabled={field.alwaysRequired}
                                                        onChange={() => this.handleToggle(field.key)}
                                                    />
                                                </Col>
                                            </Row>
                                            {field.noRegex ? null : 
                                                <div className='mt-2'>
                                                    <Label className="text-muted mb-1" style={{ fontSize: '0.85em' }}>
                                                        <FormattedMessage id="ProfileCreationConfig.RegularExpression" />
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        value={config.regex || ''}
                                                        onChange={(e) => this.handleRegexChange(field.key, e)}
                                                        placeholder={intl.formatMessage({ id: 'ProfileCreationConfig.RegularExpression' })}
                                                    />
                                                </div>
                                            }   
                                        </CardBody>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                </Form>
            </StyledCard>
        );
    }
}

export default injectIntl(ProfileCreationConfig);
